<template>
  <div class="container">
    <div class="toolbar">
      <el-date-picker v-model="params.timespan" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
        start-placeholder="开始日期" end-placeholder="结束日期" @change="timestamp = new Date().getTime()">
      </el-date-picker>
    </div>
    <div class="wrap">
      <chart_states class="panel" :params="params" :key="'state' + timestamp" style="grid-row-start: span 2" />
      <chart_users class="panel" :params="params" :key="'user' + timestamp" />
      <chart_schedule_type class="panel" :params="params" :key="'type' + timestamp" />
    </div>
  </div>
</template>


<script>
export default {
  components: {
    chart_states: () => import("./statis/_states.vue"),
    chart_users: () => import("./statis/_users.vue"),
    chart_schedule_type: () => import("@/views/job/schedule/statis/_type.vue"),
  },
  data() {
    return {
      params: {},
      timestamp: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  grid-gap: 15px;
}

.wrap {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  height: 100%;

  .panel {
    background-color: #fff;
    padding: 20px;
  }
}
</style>